import React from "react"
import Icon from "./Icon"

// Google Search results card with browser chrome, ad result, sitelinks,
// inline ratings, and a faded organic result. No event photo — pure UI mock.

const GoogleSearchResult = () => (
  <div style={{ position: "relative", width: "100%", maxWidth: 480, margin: "0 auto" }}>
    {/* AI insight chip (top-left) */}
    <div style={{
      position: "absolute", top: -18, left: -32, zIndex: 4,
      padding: "8px 12px 8px 10px",
      background: "rgba(10,30,20,.72)",
      backdropFilter: "blur(14px)", WebkitBackdropFilter: "blur(14px)",
      border: "1px solid rgba(255,255,255,.14)",
      borderRadius: 10, color: "#fff",
      display: "flex", alignItems: "center", gap: 8,
      fontSize: 12, fontWeight: 600, whiteSpace: "nowrap",
      boxShadow: "0 10px 28px rgba(0,0,0,.28)",
      animation: "vsFloat 6s ease-in-out infinite",
    }}>
      <span style={{
        width: 18, height: 18, borderRadius: 5,
        background: "linear-gradient(135deg,#4285F4,#34A853)",
        display: "flex", alignItems: "center", justifyContent: "center", color: "#fff",
      }}>
        <Icon name="sparkles" size={11} stroke={2.4}/>
      </span>
      <span>"5k st louis" · 14 keywords added</span>
    </div>

    <div style={{
      position: "relative", zIndex: 2,
      background: "#fff", borderRadius: 14,
      boxShadow: "0 30px 80px rgba(10,40,30,.40), 0 10px 24px rgba(10,40,30,.22)",
      overflow: "hidden",
      transform: "perspective(1400px) rotateY(-6deg) rotateX(2deg)",
      transformOrigin: "center",
    }}>
      <div style={{
        display: "flex", alignItems: "center", gap: 7,
        padding: "10px 12px",
        background: "#F1F3F4",
        borderBottom: "1px solid rgba(15,23,42,.06)",
      }}>
        <div style={{ width: 10, height: 10, borderRadius: "50%", background: "#FF6057" }}/>
        <div style={{ width: 10, height: 10, borderRadius: "50%", background: "#FFBD2E" }}/>
        <div style={{ width: 10, height: 10, borderRadius: "50%", background: "#27C93F" }}/>
        <div style={{
          flex: 1, marginLeft: 10,
          padding: "5px 10px",
          background: "#fff", borderRadius: 6,
          fontSize: 10.5, color: "#64748B", fontWeight: 500,
          display: "flex", alignItems: "center", gap: 6,
        }}>
          <Icon name="search" size={10}/>
          <span>google.com/search?q=5k+st+louis+this+weekend</span>
        </div>
      </div>

      <div style={{
        padding: "14px 18px 10px",
        display: "flex", alignItems: "center", gap: 14,
        borderBottom: "1px solid #F1F3F4",
      }}>
        <div style={{ display: "flex", fontSize: 18, fontWeight: 500, letterSpacing: "-.01em", fontFamily: "Arial, sans-serif" }}>
          <span style={{ color: "#4285F4" }}>G</span>
          <span style={{ color: "#EA4335" }}>o</span>
          <span style={{ color: "#FBBC04" }}>o</span>
          <span style={{ color: "#4285F4" }}>g</span>
          <span style={{ color: "#34A853" }}>l</span>
          <span style={{ color: "#EA4335" }}>e</span>
        </div>
        <div style={{
          flex: 1,
          padding: "8px 14px",
          background: "#fff", border: "1px solid #DFE1E5", borderRadius: 999,
          fontSize: 12, color: "#0F172A", fontWeight: 500,
          display: "flex", alignItems: "center", gap: 8,
          boxShadow: "0 1px 3px rgba(0,0,0,.04)",
        }}>
          <Icon name="search" size={11} stroke={2.2}/>
          <span>5k run st louis this weekend</span>
        </div>
      </div>

      <div style={{
        padding: "0 18px",
        display: "flex", gap: 20,
        fontSize: 11, fontWeight: 500, color: "#5F6368",
        borderBottom: "1px solid #F1F3F4",
      }}>
        <div style={{ padding: "10px 0", color: "#4285F4", borderBottom: "3px solid #4285F4" }}>All</div>
        <div style={{ padding: "10px 0" }}>Events</div>
        <div style={{ padding: "10px 0" }}>Maps</div>
        <div style={{ padding: "10px 0" }}>News</div>
        <div style={{ padding: "10px 0" }}>Images</div>
      </div>

      <div style={{ padding: "14px 18px 16px" }}>
        <div style={{
          display: "inline-flex", alignItems: "center", gap: 5,
          fontSize: 10, fontWeight: 700,
          padding: "2px 7px", borderRadius: 4,
          background: "#E8F0FE", color: "#1967D2",
          marginBottom: 8,
        }}>Sponsored</div>

        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
          <div style={{
            width: 22, height: 22, borderRadius: "50%",
            background: "var(--mpp-gradient)",
            display: "flex", alignItems: "center", justifyContent: "center",
            color: "#fff", fontSize: 10, fontWeight: 800,
          }}>RL</div>
          <div style={{ lineHeight: 1.15 }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: "#0F172A" }}>Riverside Landing</div>
            <div style={{ fontSize: 10.5, color: "#5F6368" }}>riversidelanding.org › riverfront-5k</div>
          </div>
        </div>

        <div style={{
          fontSize: 19, fontWeight: 500, color: "#1A0DAB",
          lineHeight: 1.25, letterSpacing: "-.005em", marginBottom: 4,
        }}>
          Riverfront 5K & Fun Run: Saturday in St. Louis
        </div>
        <div style={{
          fontSize: 12.5, color: "#4D5156", lineHeight: 1.45, marginBottom: 10,
        }}>
          Sat Apr 26 · 8AM at Riverside Landing. Chip-timed 5K, family Fun Run, free t-shirt with registration. Early-bird pricing ends Friday, register now before bibs sell out.
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 6, marginBottom: 12 }}>
          {["Register →", "Course map →", "Packet pickup →", "Past results →"].map((s, i) => (
            <div key={i} style={{ fontSize: 11.5, color: "#1A0DAB", fontWeight: 500 }}>{s}</div>
          ))}
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 10, fontSize: 11, color: "#5F6368" }}>
          <span style={{ color: "#FBBC04", letterSpacing: "1px" }}>★★★★★</span>
          <span style={{ color: "#0F172A", fontWeight: 600 }}>4.9</span>
          <span>· 1,208 runners</span>
          <span style={{ marginLeft: "auto", color: "#34A853", fontWeight: 600 }}>● Registration open</span>
        </div>
      </div>

      <div style={{
        padding: "12px 18px 14px",
        borderTop: "1px solid #F1F3F4",
        opacity: .6,
      }}>
        <div style={{ fontSize: 11, color: "#5F6368", marginBottom: 2 }}>stlrunners.com › races-this-weekend</div>
        <div style={{ fontSize: 15, fontWeight: 500, color: "#1A0DAB", lineHeight: 1.25 }}>
          Upcoming Races in St. Louis: April &amp; May
        </div>
      </div>
    </div>

    {/* CPA chip (top-right) */}
    <div style={{
      position: "absolute", top: 100, right: -24, zIndex: 4,
      padding: "10px 12px",
      background: "rgba(10,30,20,.80)",
      backdropFilter: "blur(14px)", WebkitBackdropFilter: "blur(14px)",
      border: "1px solid rgba(255,255,255,.14)",
      borderRadius: 10, color: "#fff",
      whiteSpace: "nowrap",
      boxShadow: "0 10px 28px rgba(0,0,0,.28)",
      animation: "vsFloat 8s ease-in-out -1s infinite",
    }}>
      <div style={{ fontSize: 10, fontWeight: 600, opacity: .7, letterSpacing: ".08em", textTransform: "uppercase" }}>Cost / registration</div>
      <div style={{ fontSize: 17, fontWeight: 800, letterSpacing: "-.02em", marginTop: 2 }}>
        $3.40 <span style={{ fontSize: 11, fontWeight: 700, color: "#8CEAB0" }}>▼ 22%</span>
      </div>
    </div>

    {/* Reach chip (bottom-right) */}
    <div style={{
      position: "absolute", bottom: 24, right: -46, zIndex: 4,
      padding: "10px 12px",
      background: "rgba(255,255,255,.96)",
      borderRadius: 10,
      boxShadow: "0 14px 32px rgba(10,40,30,.26)",
      display: "flex", alignItems: "center", gap: 10,
      animation: "vsFloat 7s ease-in-out -2s infinite",
    }}>
      <div style={{
        width: 30, height: 30, borderRadius: 8,
        background: "linear-gradient(135deg, #E8F0FE, #E6F4EA)",
        display: "flex", alignItems: "center", justifyContent: "center",
        color: "var(--mpp-accent)",
      }}>
        <Icon name="search" size={15} stroke={2.2}/>
      </div>
      <div style={{ lineHeight: 1.15 }}>
        <div style={{ fontSize: 10.5, fontWeight: 600, color: "#64748B", letterSpacing: ".06em", textTransform: "uppercase" }}>Search reach</div>
        <div style={{ fontSize: 12.5, fontWeight: 700, color: "#0F172A" }}>52k high-intent / wk</div>
      </div>
    </div>
  </div>
)

export default GoogleSearchResult
